// Module name (used for translations)
export const MODULE_NAME = "params";

// ModuloPEP
export const PARAMS_ROUTE_MODULO_PEP = "params/moduloPEP";
export const PARAMS_ROUTE_MODULO_PEP_FORM = "params/moduloPEP/form";

// Escola
export const PARAMS_ROUTE_ESCOLA = "params/escola";
export const PARAMS_ROUTE_ESCOLA_FORM = "params/escola/form";

// Disciplina
export const PARAMS_ROUTE_DISCIPLINA = "params/disciplina";
export const PARAMS_ROUTE_DISCIPLINA_FORM = "params/disciplina/form";

// TipoEncaminhamento
export const PARAMS_ROUTE_TIPO_ENCAMINHAMENTO = "params/tipoEncaminhamento";
export const PARAMS_ROUTE_TIPO_ENCAMINHAMENTO_FORM = "params/tipoEncaminhamento/form";

// Disciplina nivel enum values
export const DISCIPLINA_NIVEL_OPTIONS = ["BASICA", "AVANCADA"];

// Classe
export const PARAMS_ROUTE_CLASSE = "params/classe";
export const PARAMS_ROUTE_CLASSE_FORM = "params/classe/form";

// Classe nivel enum values (same as Escola)
export const CLASSE_NIVEL_OPTIONS = ["EP1", "EP2", "ESG1", "ESG2", "OUTRO"];

// Coordenação Distrital
export const PARAMS_ROUTE_COORDENACAO_DISTRITAL = "params/coordenacaoDistrital";
export const PARAMS_ROUTE_COORDENACAO_DISTRITAL_FORM = "params/coordenacaoDistrital/form";

// Ticket Category
export const PARAMS_ROUTE_TICKET_CATEGORY = "params/ticketCategory";
export const PARAMS_ROUTE_TICKET_CATEGORY_FORM = "params/ticketCategory/form";

// Ticket Channel
export const PARAMS_ROUTE_TICKET_CHANNEL = "params/ticketChannel";
export const PARAMS_ROUTE_TICKET_CHANNEL_FORM = "params/ticketChannel/form";

// Ticket Flag
export const PARAMS_ROUTE_TICKET_FLAG = "params/ticketFlag";
export const PARAMS_ROUTE_TICKET_FLAG_FORM = "params/ticketFlag/form";

// Ticket Priority
export const PARAMS_ROUTE_TICKET_PRIORITY = "params/ticketPriority";
export const PARAMS_ROUTE_TICKET_PRIORITY_FORM = "params/ticketPriority/form";

// Roles & Permissions
export const PARAMS_ROUTE_ROLE = "params/role";
export const PARAMS_ROUTE_ROLE_FORM = "params/role/form";
export const PARAMS_ROUTE_USER_ROLE = "params/role/users";
